import { useDispatch, useSelector } from 'react-redux'
import {
  getTagContactCount,
} from './TagSlice/TagsSlices'
import { GetData } from '../../../UserPages/Contacts/AllContactsList/SubscriberSlice/SubscriberSlice';

type params = {
  page: number,
  size: number,
  search: string,
}

export function useListTag() {
  const dispatch = useDispatch()

  const tagsData = useSelector((state: any) => state?.baseTags?.tags?.data)
  const TagsCount = useSelector(getTagContactCount)

  const fetchTagsData = (params?: params) => {
    dispatch(GetData(params))
  }

  return {
    fetchTagsData,
    tagslist: tagsData,
    TagsCount: TagsCount,
  }
}
